export const NEW_PROGRAM_REQUISITE_ID = 'NEW_PROGRAM_REQUISITE_ID'

export enum SCRIBE_VALIDATIONS {
  BLOCK_TYPES = 'SCR004',
  CATALOG_YEAR ='STU035',
  // BLOCK_VALUE_SCHOOLS = 'STU350',
  BLOCK_VALUE_PROGRAMS = 'STU316',
  BLOCK_VALUE_DEGREES ='STU307',
  BLOCK_VALUE_MAJORS ='STU023',
  BLOCK_VALUE_MINORS ='STU024',
  BLOCK_VALUE_CONCENTRATIONS ='STU563',
  BLOCK_VALUE_SPECIALIZATIONS ='STU323',
  BLOCK_VALUE_COLLEGES ='STU560',
}

export enum BLOCK_VALUES {
  SCHOOL = 'BLOCK_VALUE_SCHOOLS',
  PROGRAM = 'BLOCK_VALUE_PROGRAMS',
  DEGREE = 'BLOCK_VALUE_DEGREES',
  MAJOR = 'BLOCK_VALUE_MAJORS',
  MINOR = 'BLOCK_VALUE_MINORS',
  COLLEGE = 'BLOCK_VALUE_COLLEGES',
  CONC = 'BLOCK_VALUE_CONCENTRATIONS',
  SPEC = 'BLOCK_VALUE_SPECIALIZATIONS',
}
